<template lang="pug">
section.container
  .row.position-relative.justify-content-center.justify-content-lg-between.align-items-center.i_mt_10
    h2.i_h2_title 聚焦問題
    .layout_switcher.i_mr_sm_2(:class="{ stripe: isLayoutSwitcherStripe }")
      .grid_btn(@click="isLayoutSwitcherStripe = false")
        svg-icon(iconClass="grid", className="icon")
      .stripe_btn(@click="isLayoutSwitcherStripe = true")
        svg-icon(iconClass="stripe", className="icon")
  .row(v-if="!isLayoutSwitcherStripe")
    .col-6.col-md-3.i_mt_8.i_mt_md_4(
      v-for="(question, index) in questions",
      :key="index",
      v-if="index < displayAmount"
    )
      question(:question="question")
  .row(v-if="isLayoutSwitcherStripe")
    .col-12.i_mt_8.i_mt_md_4(
      v-for="(question, index) in questions",
      :key="index",
      v-if="index < displayAmount"
    )
      question-stripe(:question="question")
  .row.text-center.i_mt_8(v-if="!isExpand")
    .collapse_btn(@click="expand") 展開看更多
</template>

<script>
import QuestionStripe from "@/components/common/QuestionStripe";
import Question from "@/components/common/Question";

export default {
  name: "QuestionWrapper",
  components: {
    question: Question,
    "question-stripe": QuestionStripe,
  },
  props: {
    questions: Array,
  },
  data() {
    return {
      isLayoutSwitcherStripe: false,
      displayAmount: 4, //預設顯示4個
      isExpand: false,
    };
  },
  methods: {
    expand() {
      this.displayAmount = this.questions.length;
      this.isExpand = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 991px) {
  .layout_switcher {
    position: absolute;
    right: 0;
  }
}
</style>
